import { createRouter, createWebHistory } from "vue-router";
// import SettingsPage from "../components/Settings.vue";
// import PaymentPage from "../components/PaymentPage.vue";
import HomePage from "@/components/HomePage.vue";
import ConfigurationPage from "@/components/ConfigurtionPage.vue";
import TokenizationPage from "@/components/TokenizationPage.vue";
import WalletConfigurationPage from "@/components/WalletConfigurationPage.vue";
import WalletHomePage from "@/components/WalletHomepage.vue";
import MyMontyHomepage from "@/components/MyMontyHomepage.vue";
("@/components/MyMontyHomepage.vue");
import MyMontyConfigurationPage from "@/components/MyMontyConfigurationPage.vue";
import PaymentPage from "@/components/PaymentPage.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/wallet",
    name: "WalletHomePage",
    component: WalletHomePage,
  },
  {
    path: "/mymonty",
    name: "MyMontyHomePage",
    component: MyMontyHomepage,
  },
  {
    path: "/configurationpage",
    name: "ConfigurationPage",
    component: ConfigurationPage,
  },
  {
    path: "/tokenization",
    name: "TokenizationPage",
    component: TokenizationPage,
  },
  {
    path: "/walletconfigurationpage",
    name: "WalletConfigurationPage",
    component: WalletConfigurationPage,
  },
  {
    path: "/mymontyconfigurationpage",
    name: "MyMontyConfigurationPage",
    component: MyMontyConfigurationPage,
  },
  {
    path: "/payment",
    name: "PaymentPage",
    component: PaymentPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
